import {
  TITLE_LIEU,
  MODULE_LIEU,
  MODULE_DONNEE_REF,
  MODULE_ESPECE,
  DEFAULT_PATH,
} from "constant/moduleInfo";
import React, { useEffect, useMemo, useState } from "react";
import servicesAPI from "services/servicesAPI";
import LayoutContext from "context/LayoutContext";
import LoadComponent from "components/LoadComponent";
import DataTableComponent from "components/DataTableComponent";
import useTableLieu from "layouts/donneeReference/rubrique/gestionLieu/hooks/useTableLieu";
import permissionFetcher from "utils/permissionFetcher";
import { useNavigate, useLocation } from "react-router-dom";
import { NO_DATA_FOUND, ERROR, NO_PERMISSION } from "constant/message";
import { LAST_PATH } from "constant";
import useArrayOperation from "hooks/useArrayOperation";
import userInfos, { checkRoleExist } from "utils/userInfos";
import { SUPER_ADMIN_ROLE, ADMIN_PAYS_ROLE } from "constant/role";
import MDButton from "components/MDButton";
import { LieuContext } from "context/AppContext";

import EffectifPrevForm from "layouts/donneeReference/rubrique/gestionLieu/components/EffectifPrevForm";
import EffectifPrevAction from "layouts/donneeReference/rubrique/gestionLieu/components/EffectifPrevAction";
import { normalizeText } from "utils/textOperation";
// import CONFIG from "config";

function GestionLieu() {
  const navigate = useNavigate();
  const location = useLocation();
  // const { DEFAULT_ENTITE } = CONFIG;
  const [permissionModule, setPermissionModule] = useState([]);
  const [listData, setListData] = useState([]);
  const [showActionEffectif, setshowActionEffectif] = useState(false);
  const [listEspece, setListEspece] = useState([]);
  const [openEffectifPrev, setOpenEffectifPrev] = useState(false);
  const [openEffectifPrevAction, setOpenEffectifPrevAction] = useState(false);
  const { isAlert, isLoading, message, alertSeverity, handleLoad, postData, getData } =
    servicesAPI();
  const { columns, rows, renderDataTable, selectedItem, actionOption, onSelectedRow } =
    useTableLieu();
  const { customArrItem, removeDuplicateItem } = useArrayOperation();

  const CODE_PAYS = userInfos()?.lieu?.codePays;
  const USER_DATA = userInfos();
  const getAllData = async () => {
    const fetchData = await getData(MODULE_LIEU);
    if (fetchData !== ERROR) {
      const result = fetchData
        .filter((i) => i.codePays === CODE_PAYS)
        .map((i) => {
          return {
            ...i,
            codeLieu: `${i?.codeRegion ?? ""}${i?.codeDepart ?? ""}${i?.codeCommune ?? ""}`,
          };
        });
      const customArr = customArrItem(result, MODULE_LIEU);
      if (customArr.length > 0) {
        setListData(customArr);
        renderDataTable(customArr);
      } else {
        const loadData = {
          isAlert: true,
          message: "Aucun lieu trouvé",
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
      }
    }
  };
  const handleCloseEffectifPrevAction = () => {
    setOpenEffectifPrevAction(false);
  };
  const handleCloseEffectifPrev = () => {
    setOpenEffectifPrev(false);
    onSelectedRow({}, "");
  };
  const saveEffectifData = async (data) => {
    const fetchData = await postData("campagnEffectif", data);
    if (fetchData !== ERROR) {
      setTimeout(() => {
        handleCloseEffectifPrev();
        getAllData();
      }, 200);
    }
  };
  const getPermission = () => {
    const permissionArray = permissionFetcher(MODULE_DONNEE_REF);
    if (permissionArray.find((i) => i.name.includes(`Consulter${MODULE_DONNEE_REF}`))) {
      const permission = permissionArray.filter((i) => i.name !== `Insert${MODULE_DONNEE_REF}`);
      setPermissionModule(permission);
      getAllData();
    } else {
      const loadData = {
        isAlert: true,
        message: NO_PERMISSION,
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
      setTimeout(() => {
        navigate(DEFAULT_PATH);
      }, 2000);
    }
  };
  const getEspece = async () => {
    const fetchData = await getData(MODULE_ESPECE);
    let espece = [];
    if (fetchData !== ERROR) {
      espece = fetchData;
    }
    return espece;
  };

  useEffect(async () => {
    getPermission();
    localStorage.setItem(LAST_PATH, location.pathname);
    const isSuperAdmin = checkRoleExist(SUPER_ADMIN_ROLE);
    const isAdminPays = checkRoleExist(ADMIN_PAYS_ROLE);
    // const userEntity = normalizeText(userInfos()?.entite);
    // const userEntity = CurrentUserEntite();

    if (
      isSuperAdmin ||
      // (isAdminPays && DEFAULT_ENTITE.includes(userEntity) && userInfos()?.especeCategory === "ALL")
      (isAdminPays && USER_DATA?.entite?.isAutorite && userInfos()?.especeCategory === "ALL")
    ) {
      setshowActionEffectif(true);
      const especeData = await getEspece();
      setListEspece(especeData);
    }
  }, []);
  const handleSearch = (value) => {
    if (value === "") {
      renderDataTable(listData);
    } else {
      const searchTerm = normalizeText(value);
      console.log("search", searchTerm);
      const filteredData = listData.filter((item) => {
        if (searchTerm === normalizeText(item?.region)) {
          console.log("ee", item?.region);
        }
        return (
          normalizeText(item?.localite).includes(searchTerm) ||
          normalizeText(item?.region).includes(searchTerm) ||
          normalizeText(item?.departement).includes(searchTerm) ||
          normalizeText(item?.commune).includes(searchTerm) ||
          normalizeText(item?.codeLieu).includes(searchTerm)
        );
      });
      if (filteredData.length > 0) {
        renderDataTable(filteredData);
      } else {
        const loadData = {
          isAlert: true,
          message: NO_DATA_FOUND,
          isLoading: false,
          alertSeverity: "error",
        };
        handleLoad(loadData);
      }
    }
  };

  const exportedData = () => {
    const listLieu = removeDuplicateItem(listData, "departement");

    const ListDepartement = listLieu
      .filter((i) => i.codePays === CODE_PAYS)
      .map((i) => i.departement);

    const enteteFile = ["", ...ListDepartement];
    const especeData = listEspece.map((i) => {
      const item = [i.nomCourant, ...new Array(ListDepartement.length).fill(0)];
      return item;
    });
    const worksheetData = [enteteFile, ...especeData];
    return worksheetData;
  };
  const contextValue = useMemo(() => {
    const value = {
      title: TITLE_LIEU,
      columns,
      rows,
      permissionModule,
      module: MODULE_DONNEE_REF,
      selectedItem,
      actionOption,
      onSelectedRow,
      handleSearch,
      refreshData: getAllData,
    };
    return value;
  }, [columns, rows, permissionModule, selectedItem, actionOption]);
  const contextLieuValue = useMemo(() => {
    const value = {
      handleClose: handleCloseEffectifPrev,
      handleOpen: setOpenEffectifPrev,
      open: openEffectifPrev,
      handleCloseAction: handleCloseEffectifPrevAction,
      openAction: openEffectifPrevAction,
      selectedItem,
      listEspece,
      listLieu: listData,
      saveData: saveEffectifData,
      exportedData,
    };
    return value;
  }, [openEffectifPrev, openEffectifPrevAction, selectedItem, listEspece]);

  return (
    <div>
      <LayoutContext.Provider value={contextValue}>
        <DataTableComponent />
      </LayoutContext.Provider>
      <LieuContext.Provider value={contextLieuValue}>
        {showActionEffectif && (
          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            onClick={() => setOpenEffectifPrevAction(true)}
            style={{ marginTop: 10 }}
          >
            Effectif Prévisionnel
          </MDButton>
        )}
        <EffectifPrevAction />
        <EffectifPrevForm />
      </LieuContext.Provider>
      <LoadComponent loadData={{ isAlert, isLoading, message, alertSeverity, handleLoad }} />
    </div>
  );
}

export default GestionLieu;
